import { Stack, Typography } from "@mui/material";
import { CarrierSuggestionBadge } from "../../shared/ui/base-badge";

export const NullableValueText = ({
  value,
  emphasis,
}: { value: string | null | undefined; emphasis?: boolean }) => {
  const valueColor = emphasis ? "primary.500" : value ? "grey.900" : "grey.500";
  return (
    <Typography
      variant="body2"
      color={valueColor}
      fontWeight={emphasis ? 700 : 400}
    >
      {value ? value : "未記入"}
    </Typography>
  );
};

export const ValueWithLabel = ({
  label,
  value,
  emphasis,
  fromCarrier,
}: {
  label: string;
  value: string | null | undefined;
  emphasis?: boolean;
  fromCarrier?: boolean;
}) => {
  return (
    <Stack direction="row" alignItems={"center"} spacing={0.5} flexWrap="wrap">
      <Typography variant="body2" color="grey.900">
        {label}
      </Typography>
      {fromCarrier ? <CarrierSuggestionBadge /> : null}
      <Typography variant="body2" color="grey.900">
        :
      </Typography>
      <NullableValueText value={value} emphasis={emphasis} />
    </Stack>
  );
};
